import { Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { ACCEPTED_FILE_TYPES, MAX_IMAGE_SIZE, useTranslation } from "@next-platform/client-common-core";

import { Col } from "@/components";
import { cn } from "@/utils";

interface IImageDropOverlayProps {
  isVisible: boolean;
  isValidFileType: boolean;
}

export default function ImageDropOverlay({ isVisible, isValidFileType }: IImageDropOverlayProps) {
  const { t } = useTranslation();
  if (!isVisible) return null;

  const fileTypes = ACCEPTED_FILE_TYPES.map((type) => type.replace("image/", "").toUpperCase());
  const lastType = fileTypes[fileTypes.length - 1];
  const otherTypes = fileTypes.slice(0, fileTypes.length - 1).join(", ");

  const content = isValidFileType
    ? {
        icon: IconVariants.IMAGE_PLUS,
        title: t("chat:page.input.imageUpload.dropAndUpload"),
        description: t("chat:page.input.imageUpload.maxSize", { size: MAX_IMAGE_SIZE }),
        className: "border-blue-10 bg-blue-1",
      }
    : {
        icon: IconVariants.ALERT_TRIANGLE,
        title: t("chat:page.input.imageUpload.onlyImageFiles"),
        description: t("chat:page.input.imageUpload.allowedFormats", { otherTypes, lastType }),
        className: "border-red-7 bg-red-1",
      };

  return (
    <div className="absolute inset-0 z-[9999] flex items-center justify-center bg-black/[0.26]">
      <Col
        className={cn(
          "items-center justify-center w-[300px] min-h-[162px] max-w-full mx-md pointer-events-none border-2 border-dashed rounded-lg gap-lg",
          content.className,
        )}
      >
        <Icon icon={content.icon} size={IconSize.XLARGE} />
        <Col className="*:text-center gap-0.5">
          <Text variant={TextVariants.LABEL_MEDIUM_BOLD} className="text-gray-12">
            {content.title}
          </Text>
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-10">
            {content.description}
          </Text>
        </Col>
      </Col>
    </div>
  );
}
